import React from "react";

const PaymentPolicy = () => {
  return (
    <div className="bg-gray-100 py-10 px-4">
      <div className="max-w-5xl mx-auto bg-white border border-gray-300 rounded-xl p-8 shadow-lg">
        
        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-bold text-center text-[#1E3A8A] mb-6">
          Payment Policy & Terms & Conditions
        </h1>

        {/* Paragraph intro */}
        <p className="text-gray-600 text-center text-sm sm:text-base mb-8 max-w-2xl mx-auto">
          Please read the following policies carefully before completing a booking with BookTrip4Me.
        </p>

        {/* Policy List */}
        <ol className="list-decimal pl-6 space-y-4 text-gray-800 text-sm sm:text-base leading-relaxed">
          <li>
            <strong>Accepted Payment Methods:</strong> We accept all major credit cards, debit cards,
            and electronic transfers. ACH/Wire details are available upon request.
          </li>

          <li>
            <strong>Customer Acknowledgment:</strong> The customer agrees to remit full payment for airfare,
            hotel, rental cars, cruises, taxes, and any applicable service fees.
          </li>

          <li>
            <strong>Payment Timeliness:</strong> Payments must be made promptly to secure your itinerary.
            Providers may offer a 24-hour hold for final payments.
          </li>

          <li>
            <strong>Credit Authorization Process:</strong> Bookings may require verification through
            DocuSign, email approval, or copies of credit card and ID.
          </li>

          <li>
            <strong>Chargebacks:</strong> If a chargeback is initiated, the documented customer approval
            will be submitted to the payment gateway as evidence.
          </li>

          <li>
            <strong>Fare Guarantees:</strong> Fares are not guaranteed until ticketed, even if payment
            details have been submitted.
          </li>

          <li>
            <strong>Split Charges:</strong> Your card may be billed in multiple transactions, not exceeding
            the total amount.
          </li>

          <li>
            <strong>Customer Consent:</strong> Customers confirm and approve the total amount in the itinerary.
          </li>

          <li>
            <strong>Booking Confirmation:</strong> E-tickets or confirmations will be emailed to the address
            provided at checkout.
          </li>

          <li>
            <strong>Itinerary Verification:</strong> Customers must review names, dates, and destinations.
            Changes may incur penalties or may not be possible on the same day.
          </li>

          <li>
            <strong>Provider Policies:</strong> Customers are responsible for reviewing airline/hotel/car
            rules. BookTrip4Me is not liable for errors or penalties imposed by providers.
          </li>

          <li>
            <strong>Baggage Fees:</strong> Prices may not include luggage fees. Please contact the airline
            directly for updated baggage policies.
          </li>

          <li>
            <strong>Hotel, Car, Cruise Policies:</strong> Customers should confirm what is included under the
            respective service provider’s terms.
          </li>

          <li>
            <strong>Travel Documents:</strong> Passengers must possess valid passports, IDs, and any required travel documents.
          </li>

          <li>
            <strong>Visa Responsibilities:</strong> BookTrip4Me is not responsible for visa approvals. Please consult the destination embassy.
          </li>

          <li>
            <strong>Travel Insurance:</strong> Strongly recommended. We can provide insurance quotes upon request.
          </li>

          <li>
            <strong>Schedule Changes:</strong> Airline schedules may change. We recommend reviewing your
            flight status 48 hours before departure.
          </li>
        </ol>

        {/* Notification Section */}
        <div className="mt-10 border-t pt-6">
          <h2 className="text-lg sm:text-xl font-semibold text-yellow-600">
            Notification of Delays & Cancellations
          </h2>
          <p className="text-gray-700 mt-1 text-sm sm:text-base">
            Please subscribe to your airline’s flight alerts for delays and cancellations.
          </p>
        </div>

        {/* Rebooking Section */}
        <div className="mt-6">
          <h2 className="text-lg sm:text-xl font-semibold text-green-700">
            Rebooking Assistance
          </h2>
          <p className="text-gray-700 mt-1 text-sm sm:text-base">
            If your booking is cancelled and you need to rebook, our support team is available
            to assist you with alternate options.
          </p>
        </div>

      </div>
    </div>
  );
};

export default PaymentPolicy;
